import React from 'react'
import { Trans } from '@lingui/react/macro'
import { graphql, useFragment } from 'react-relay'
import { useLocation, useNavigate } from 'react-router-dom'

import { XStack } from 'tamagui'

import { Button, ButtonProps } from '../Button/Button'
import { Icon } from '../Icon'

import { CreateEventButton_guild$key } from './__generated__/CreateEventButton_guild.graphql'

/**
 * Opens the new Event dialog. With a Guild, the dialog preselects that Guild
 * and the button only renders for people who can create Events for it.
 */
export const CreateEventButton = ({
  guild,
  ...props
}: {
  guild?: CreateEventButton_guild$key | null
} & Omit<ButtonProps, 'onPress'>) => {
  const data = useFragment(
    graphql`
      fragment CreateEventButton_guild on Guild {
        slugId
        viewerCanCreateEvents
      }
    `,
    guild ?? null
  )

  const navigate = useNavigate()
  const location = useLocation()

  if (guild && !data?.viewerCanCreateEvents) {
    return null
  }

  const href = data?.slugId
    ? `/events/new?guild=${encodeURIComponent(data.slugId)}`
    : '/events/new'

  return (
    <Button
      secondary
      errorFlash={false}
      paddingHorizontal='$4'
      {...props}
      onPress={() => {
        navigate(href, {
          state: {
            backgroundLocation:
              (location.state as { backgroundLocation?: unknown } | null)
                ?.backgroundLocation || location,
          },
        })
      }}
    >
      <XStack gap='$2' alignItems='center'>
        <Icon name='calendar-add' size='$5' color='$color' />

        <Button.Text>
          <Trans>Create Event</Trans>
        </Button.Text>
      </XStack>
    </Button>
  )
}
